import React, { useState } from "react";
import {
  Box,
  Tab,
  Tabs,
} from "@mui/material";
import ImportFromPhone from "./ImportFromPhone";
import ImportFromEmail from "./ImportFromEmail";
import ImportFromWhatsApp from "./ImportFromWhatsApp";
import ImportFromChat from "./ImportFromChat";
import AdminLoader from "./AdminLoader";
import MWPageTitle from "../component/MWPageTitle";
import PageLayout from "./Layout/PageLayout";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ mt: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ImportData() {
  const [selected, setSelected] = useState(0);
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelected(newValue);
  };
  const loadingMarkup = <AdminLoader />;
  const [importFromPhoneLoader, setImportFromPhoneLoader] = useState(false);
  const importPage = (
    <Box>
      <Tabs value={selected} onChange={handleTabChange}>
        <Tab label="Import From Phone" {...a11yProps(0)} />
        <Tab label="Import From Email" {...a11yProps(1)} />
        <Tab label="Import From WhatsApp" {...a11yProps(2)} />
        <Tab label="Import From Chat" {...a11yProps(3)} />
      </Tabs>
      <TabPanel value={selected} index={0}>
        <ImportFromPhone importFromPhoneLoader={setImportFromPhoneLoader} />
      </TabPanel>
      <TabPanel value={selected} index={1}>
        <ImportFromEmail />
      </TabPanel>
      <TabPanel value={selected} index={2}>
        <ImportFromWhatsApp />
      </TabPanel>
      <TabPanel value={selected} index={3}>
        <ImportFromChat />
      </TabPanel>
    </Box>
  );

  return (
    <Box>
      {importFromPhoneLoader ? loadingMarkup : null}
      <PageLayout>
        <MWPageTitle title={"Import Data"} />
        {importPage}
      </PageLayout>
    </Box>
  );
}
